module.exports = __webpack_public_path__ + "media/37.84b746db.wav";